module.exports = __webpack_public_path__ + "img/right.04061efb.svg";